













































import axios from 'axios';
import moment from 'moment-timezone';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { BaseVue } from '@/BaseVue';
import CreateInventoryView from '@/components/inventory/CreateInventoryView.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import UiDataTable from '@/components/ui/UiDataTable.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import UiSelect2 from '@/components/ui/UiSelect2.vue';
import WalletListNew from '@/components/wallets/WalletListNew.vue';
import { store } from '@/store';
import { MUT_GET_SUBS } from '@/store/modules/subsidiaries/types';
import { MUT_GET_WALLETS } from '@/store/modules/wallets/types';
import { getClusterAwareBaseUrl } from '@/utils/clusterAwareUrl';
import { clearDownloadIframes, downloadAuthorizedFile } from '@/utils/downloadFile';
import { downloadExportFiles, type ExportResponse } from '@/utils/exportResponseHandler';
import numberUtils from '@/utils/numberUtils';

import { baConfig } from '../../../../config';
import { ApiSvcInventoryView, InventoryApi } from '../../../../generated/api-svc';
@Component({
  components: {
    UiCheckbox,
    CreateInventoryView,
    UiDatePicker,
    UiButton,
    UiSelect2,
    WalletListNew,
    UiDataTable,
  },
})
class InventoryActionsReport extends BaseVue {
  @Prop({ default: null })
  public readonly view!: ApiSvcInventoryView | null;

  public startDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');
  public endDate = moment.tz(moment.tz.guess()).subtract(1, 'day').format('YYYY-MM-DD');

  public numFormat = numberUtils.getFormatter({ accountingNegative: true });

  public csvLoading = false;
  public selectedSubsidiaryIds: string[] = [];
  public selectedWalletIds: string[] = [];

  public baseUrl = getClusterAwareBaseUrl(process.env.VUE_APP_RPT_API_URL ?? process.env.VUE_APP_API_URL ?? '');

  private downloadFile = downloadAuthorizedFile;

  async downloadReport() {
    if (this.view && this.view.id) {
      if (!this.baseUrl) {
        console.error('Base URL is not configured');
        return;
      }

      this.csvLoading = true;

      const frames = (this.$refs.inventoryViewContainer as Element)?.querySelectorAll('iframe.temp-iframe');
      if (frames?.length) {
        (this.$refs.inventoryViewContainer as Element)?.removeChild(frames[0]);
      }

      try {
        const svc = new InventoryApi(undefined, baConfig.getFriendlyApiUrl());
        const p1 = svc.getInventoryEnhancedGainLoss(
          this.orgId,
          this.view.id,
          this.startDate,
          this.endDate,
          true,
          undefined,
          this.selectedSubsidiaryIds.length > 0 ? this.selectedSubsidiaryIds : undefined,
          this.selectedWalletIds.length > 0 ? this.selectedWalletIds : undefined,
          {
            withCredentials: true,
            headers: {
              Accept: 'application/zip',
            },
          }
        );

        const resp = await p1;

        if (resp.status === 200) {
          clearDownloadIframes();

          // Use the new export response handler
          await downloadExportFiles(
            resp.data as ExportResponse,
            this.baseUrl,
            this.$store.state.currentOrg.id,
            (url: string) => this.downloadFile(url)
          );
        }
      } finally {
        this.csvLoading = false;
      }
    }
  }

  get subsidiaries() {
    return store.getters['subsidiaries/SUBSIDIARIES'] || [];
  }

  get wallets() {
    return store.getters['wallets/WALLETS'] || [];
  }

  async mounted() {
    const orgId = store.state.currentOrg.id;
    await Promise.all([
      store.dispatch('subsidiaries/' + MUT_GET_SUBS, { orgId }),
      store.dispatch('wallets/getWallets', orgId),
    ]);
  }
}
export default InventoryActionsReport;
